import React from "react";

import SmallScreen from "~/components/Icons/svg/smallScreen";
import { ChartBarIvideon } from "~/components/Chart";
import { dataContentInfoCardCar } from "~/pages/IvideonDealerSummary2/options";

import { dataBarIProps, LabelsType } from ".";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

interface ItemChartCarIProps {
  variant: string;
  dataBar: dataBarIProps;
  labels: LabelsType;
  isLoading: boolean;
  handleVariant: (prop: null) => void;
}

interface variantIProps {
  label: string;
  value: keyof dataBarIProps;
  title: string;
}
const ItemChartCar = ({
  variant,
  dataBar,
  labels,
  isLoading,
  handleVariant,
}: ItemChartCarIProps) => {
  return (
    <div className={styles.cardGraph}>
      <div className={styles.cardTitleWrapper}>
        <span className={styles.cardTitle}>{JSON.parse(variant).title}</span>
        <div className={styles.itemTitleWrapper}>
          {JSON.parse(variant).value !== "uniqueVehicles" ? (
            <>
              <div className={styles.itemTitle}>
                <div className={styles.colorItemOrange}></div>
                <span>{dataContentInfoCardCar[0].label}</span>
              </div>
              <div className={styles.itemTitle}>
                <div className={styles.colorItemGray}></div>
                <span>{JSON.parse(variant).label}</span>
              </div>
            </>
          ) : null}
          <div className={styles.wrappIcon} onClick={() => handleVariant(null)}>
            <SmallScreen />
          </div>
        </div>
      </div>
      <ChartBarIvideon
        chartContainer={styles.chartContainer}
        data={
          JSON.parse(variant)?.value === "uniqueVehicles"
            ? [dataBar.uniqueVehicles]
            : [
                dataBar.uniqueVehicles,
                dataBar[(JSON.parse(variant) as variantIProps).value],
              ]
        }
        label={labels}
        isLoading={isLoading}
        dataContentInfoCardCar={
          JSON.parse(variant).value === "uniqueVehicles"
            ? [JSON.parse(variant)]
            : [dataContentInfoCardCar[0], JSON.parse(variant)]
        }
      />
    </div>
  );
};

export default ItemChartCar;
